module.exports = __webpack_public_path__ + "img/img3006.a1a70732.jpg";